import React, { useEffect, useState } from 'react';
import { Box, InputBase, IconButton, Divider, FormControl, FormLabel, FormControlLabel, RadioGroup, Radio, Select, MenuItem, useTheme } from '@mui/material';
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { borderRadius } from '../constants';
import { designTokens } from '../theme/designTokens';

const Search = ({
    getDistinctColumnValues,
    setPage,
    searchValue,
    setSearchValue,
    setSelection,
}) => {
    const [radioSelectionValue, setRadioSelectionValue] = useState('contains');
    const theme = useTheme();

    useEffect(() => {
        if (setSelection) {
            setSelection({ name: 'contains', value: 'contains' });
        }
    }, []);

    const handleRadioSelectionValueChange = (value) => {
        setRadioSelectionValue(value);
        let selectionObj;
        if (value === 'contains') {
            selectionObj = {
                name: 'contains',
                value: 'contains'
            }
        } else if (value === 'beginsWith') {
            selectionObj = {
                name: 'begins with',
                value: 'beginsWith'
            }
        } else if (value === 'endsWith') {
            selectionObj = {
                name: 'ends with',
                value: 'endsWith'
            }
        }
        setSelection(selectionObj);
    }

    const handleSearch = (searchValue) => {
        setPage(1); // Reset the page number to 1 on a new search
        getDistinctColumnValues(searchValue, true, 1, null, radioSelectionValue);
    };


    return (
        <>
            <Box
                sx={{
                    p: 0,
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "surface.raised",
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: borderRadius,
                }}
            >
                <Select
                    size='small'
                    value={radioSelectionValue}
                    onChange={(e) => handleRadioSelectionValueChange(e.target.value)}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                boxShadow: theme.palette.mode === 'dark'
                                    ? designTokens.shadows.lg
                                    : designTokens.shadows.md,
                                border: `1px solid ${theme.palette.mode === 'dark'
                                    ? theme.palette.grey[700]
                                    : theme.palette.grey[200]}`,
                                mt: 0.5
                            }
                        }
                    }}
                >
                    <MenuItem value={"contains"}>Contains</MenuItem>
                    <MenuItem value={"beginsWith"}>Begins With</MenuItem>
                    <MenuItem value={"endsWith"}>Ends With</MenuItem>
                </Select>
                <InputBase
                    fullWidth
                    value={searchValue}
                    sx={{
                        paddingLeft: '10px'
                    }}
                    placeholder="Enter search value"
                    onChange={(event) => setSearchValue(event.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleSearch(e.target.value);
                        }
                    }}
                    endAdornment={
                        searchValue?.length > 0 && (
                            <IconButton
                                sx={{ p: "10px" }}
                                aria-label="cancel"
                                onClick={() => {
                                    setSearchValue('');
                                    setPage(1);
                                    getDistinctColumnValues('', true, 1);
                                }}
                            >
                                <CancelOutlinedIcon fontSize="small" />
                            </IconButton>
                        )
                    }
                    size="small"
                />
                <Divider orientation="vertical" flexItem />
                <IconButton
                    sx={{
                        p: 1,
                        backgroundColor: 'primary.main',
                        color: 'primary.contrastText',
                        '&:hover': { backgroundColor: 'primary.dark' },
                        borderRadius: '0 8px 8px 0'
                    }}
                    aria-label="search"
                    size="small"
                    onClick={() => {
                        console.log('clicked', searchValue)
                        handleSearch(searchValue);
                    }}
                >
                    <SearchIcon />
                </IconButton>
            </Box>

        </>
    )
}

export default Search